import { styled } from "theme/default/styled";

export const SFetchedFilterSelectSelectContainer = styled.div`
  position: relative;
`;
